import api from './api';
import { Department } from '../types/department';
import { PaginatedResponse } from '../types/document';

export interface CreateDepartmentData {
  name: string;
  slug: string;
  ad_group_name: string;
  description?: string;
}

export interface UpdateDepartmentData {
  name?: string;
  slug?: string;
  ad_group_name?: string;
  description?: string;
  is_active?: boolean;
}

let activeDepartmentsCache: Department[] | null = null;
let activeDepartmentsRequest: Promise<Department[]> | null = null;

export const getDepartments = () =>
  api.get<PaginatedResponse<Department>>('/documents/departments').then(r => r.data);

export const getActiveDepartments = (): Promise<Department[]> => {
  if (activeDepartmentsCache) return Promise.resolve(activeDepartmentsCache);
  if (activeDepartmentsRequest) return activeDepartmentsRequest;

  activeDepartmentsRequest = api.get<Department[]>('/documents/departments/active')
    .then(r => {
      activeDepartmentsCache = r.data;
      return r.data;
    })
    .finally(() => {
      activeDepartmentsRequest = null;
    });

  return activeDepartmentsRequest;
};

export const invalidateActiveDepartments = () => {
  activeDepartmentsCache = null;
};

export const createDepartment = (data: CreateDepartmentData) =>
  api.post<Department>('/documents/departments', data).then(r => {
    invalidateActiveDepartments();
    return r.data;
  });

export const updateDepartment = (id: number, data: UpdateDepartmentData) =>
  api.put<Department>(`/documents/departments/${id}`, data).then(r => {
    invalidateActiveDepartments();
    return r.data;
  });

export const deleteDepartment = (id: number) =>
  api.delete(`/documents/departments/${id}`).then(response => {
    invalidateActiveDepartments();
    return response;
  });
